'use client';

import styled from 'styled-components';

import { Spacers } from '@styles/theme';

export const IntroductionContainer = styled.div`
  // Label spacing
  label {
    margin-bottom: ${Spacers.XS}rem;
  }

  // TextGroup spacing
  > div:nth-child(2) {
    margin-bottom: ${Spacers.XXL}rem;

    h1 {
      padding-bottom: ${Spacers.XS}rem;
    }
  }
`;
